import { render } from "./NotFoundComponent.vue?vue&type=template&id=dcff048c&scoped=true"
const script = {}

import "./NotFoundComponent.vue?vue&type=style&index=0&id=dcff048c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dcff048c"

export default script